import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHero from "../components/PageHero";
import FadeIn from "../components/FadeIn";
import { CATEGORIES } from "../mock";
import useSEO from "../hooks/useSEO";

const Catalog = () => {
  useSEO({
    title: "Catalog — Commodity Products",
    description: "Browse Prime Trade's commodity catalog: Agriculture & food (Wheat, Rice, Sugar), Fertilizers & Chemicals (Urea, MOP, DAP, Sulphur), and Oil & Gas (Diesel EN 590, LPG).",
  });
  return (
    <main>
      <PageHero title="Products" eyebrow="Products" breadcrumbs={[{ label: "Products" }]} />

      <section className="pt-section">
        <div className="max-w-[1280px] mx-auto px-6">
          <FadeIn>
            <p className="max-w-3xl text-[15px] text-[#4a4a4a] leading-relaxed mb-10">
              You will find a comprehensive offering across five core verticals. We adhere to an integrated approach to business and are happy to establish work with new partners. We work with major brands and proven individual entrepreneurs alike.
            </p>
          </FadeIn>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {CATEGORIES.map((c, i) => (
              <FadeIn key={c.slug} delay={i * 70}>
                <Link to={`/catalog/${c.slug}`} className="pt-cat-card block group">
                  <div className="img-wrap">
                    <span className="count-badge">{c.count} products</span>
                    <img src={c.image} alt={c.name} />
                  </div>
                  <div className="p-6 flex items-start justify-between gap-4">
                    <div>
                      <h3>{c.name}</h3>
                      <p className="text-[13px] text-[#7a7a7a] mt-2 line-clamp-2">{c.description}</p>
                    </div>
                    <span className="w-10 h-10 flex items-center justify-center bg-[#f4f4f4] text-[#2c2c2c] group-hover:bg-[#e30613] group-hover:text-white transition-colors shrink-0 rounded-sm">
                      <ArrowRight size={16} />
                    </span>
                  </div>
                </Link>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

export default Catalog;
